import { render, staticRenderFns } from "./ChatSystemPrompt.vue?vue&type=template&id=6bb958fe&scoped=true"
import script from "./ChatSystemPrompt.vue?vue&type=script&lang=js"
export * from "./ChatSystemPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb958fe",
  null
  
)

export default component.exports